import {
  ADM_FORMAT,
  ADM_FORMAT_PREVIEW,
  ADM_FORMATS_TEMPLATES,
  FORMAT_OPTIONS,
} from "campaign-builder/domain/constants";

export const BEST_SELLER_FORMAT = ADM_FORMAT.POSTCARD_9x6;

export interface AdmFormatMeta {
  value: ADM_FORMAT;
  label: string; // e.g. 'Postcard 6" × 9"'
  sizeLabel: string; // e.g. '6.00 × 9.00 in'
  price: string; // '$' | '$$' | '$$$' | '$$$$'
  image?: string;
  template?: string;
  isBestSeller: boolean;
}

const isAdmFormat = (value: string): value is ADM_FORMAT => Object.values(ADM_FORMAT).includes(value as ADM_FORMAT);

export const getAdmFormatMeta = (value?: string | null): AdmFormatMeta | null => {
  if (!value || !isAdmFormat(value)) return null;
  const preview = ADM_FORMAT_PREVIEW[value];
  const option = FORMAT_OPTIONS.find((o) => o.value === value);
  const height = preview.heightInInch;
  const width = preview.widthInInch;
  return {
    value,
    label: `Postcard ${height}" × ${width}"`,
    sizeLabel: `${height.toFixed(2)} × ${width.toFixed(2)} in`,
    price: option?.bottomText ?? "",
    image: option?.image,
    template: ADM_FORMATS_TEMPLATES[value],
    isBestSeller: value === BEST_SELLER_FORMAT,
  };
};

export const getAdmFormatList = (allowed?: string[]): AdmFormatMeta[] => {
  const values = allowed?.length ? allowed : Object.values(ADM_FORMAT);
  return values.map((value) => getAdmFormatMeta(value)).filter((meta): meta is AdmFormatMeta => meta !== null);
};
